import { useEffect, useState, useRef } from 'react';

export default function Features() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      icon: 'ri-map-pin-range-line',
      title: 'Mesafeni Sen Belirle',
      description: '500 metreden 5 kilometreye kadar yayın çapını ayarla. Mahallenden başla, dilersen tüm şehre ulaş.',
    },
    {
      icon: 'ri-grid-line',
      title: '4 Farklı İlan Tipi',
      description: 'Ürün sat, hizmet sun, ihtiyacını talep et veya etkinlik duyurusu yap. Düğün, kermes, mahalle toplantısı...',
    },
    {
      icon: 'ri-alarm-warning-line',
      title: 'Acil Yardım',
      description: 'İlaç, bebek bezi, yiyecek... Acil ihtiyaçlarında en yakın 5 komşuya anında bildirim gider.',
    },
    {
      icon: 'ri-verified-badge-line',
      title: 'Güvenilir Topluluk',
      description: 'Kimlik doğrulama, güven puanı ve rozetlerle tanımadığın komşunu bile güvenle tanı.',
    },
  ];

  return (
    <section id="features" ref={sectionRef} className="py-20 bg-[#f8f7f6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#111827] mb-4">
            Neden Mahallebi?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Mahallenizdeki güvenilir komşularınızla alışverişin en kolay ve güvenli yolu
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl p-5 sm:p-8 shadow-md hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-16 h-16 bg-[#e77e23] rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#111827] mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}